import * as CSS from "csstype"

export const colorKeys = [
	"navy",
	"white",
	"blue125",
	"blue100",
	"blue66",
	"blue33",
	"blue11",
	"purple100",
	"purple66",
	"purple33",
	"purple11",
	"plum100",
	"plum66",
	"plum33",
	"plum11",
	"green100",
	"green66",
	"green33",
	"green11",
	"coral100",
	"coral66",
	"coral33",
	"coral11",
	"yellow100",
	"yellow66",
	"yellow33",
	"yellow11",
	"grey81",
	"greyA6",
	"greyEE",
	"greyF3",
	"beige",
	"bodyColor",
	"bodyTextColor",
	"primary",
	"secondary",
	"alert",
	"success",
	"successNice",
	"hoverBlue",
	"placeholder",
] as const

export type ColorKeys = typeof colorKeys[number]

// Primaries
const navy = "#0D3050"
const white = "#FFFFFF"

// Blue
const blue125 = "#407EC9"
const blue100 = "#729fd4"
const blue66 = "#a2c0e3"
const blue33 = "#d1dff1"
const blue11 = "#f0f4fa"

// Plum
const plum100 = "#594E74"
const plum66 = "#928AA3"
const plum33 = "#C8C5D1"
const plum11 = "#EDECF0"

// Purple
const purple100 = "#c9bdd1"
const purple66 = "#dbd4e1"
const purple33 = "#ede9f0"
const purple11 = "#f9f8fa"

// Green
const green100 = "#c8d3af"
const green66 = "#dbe2ca"
const green33 = "#edf1e5"
const green11 = "#f9faf6"

// Coral
const coral100 = "#E56549"
const coral66 = "#EE9A87"
const coral33 = "#F6CCC3"
const coral11 = "#FCEEEB"

// Yellow
const yellow100 = "#F8D662"
const yellow66 = "#FAE498"
const yellow33 = "#FDF1CB"
const yellow11 = "#FEFAEE"


// Grey
const grey81 = "#818181"
const greyA6 = "#a6a6a6"
const greyEE = "#eeeeee"
const greyF3 = "#f3f3f3"

// Beige
const beige = "#F4F2EF"

// Alert colors
const alertRed = "#A80000"
const alertGreenSuccess = "#8DC63F"
const alertGreenNice = "#3AC57E"

// Hover
const hoverBlue = "#1c5dac"

// Input placeholder color
const placeholder = "#8697a7"

export const colors: Record<ColorKeys, CSS.Property.Color> = {
	white,
	navy,
	blue125,
	blue100,
	blue66,
	blue33,
	blue11,
	purple100,
	purple66,
	purple33,
	purple11,
	plum100,
	plum66,
	plum33,
	plum11,
	green100,
	green66,
	green33,
	green11,
	coral100,
	coral66,
	coral33,
	coral11,
	yellow100,
	yellow66,
	yellow33,
	yellow11,
	grey81,
	greyA6,
	greyEE,
	greyF3,
	beige,
	bodyColor: white,
	bodyTextColor: navy,
	primary: navy,
	secondary: blue33,
	alert: alertRed,
	success: alertGreenSuccess,
	successNice: alertGreenNice,
	hoverBlue,
	placeholder,
}
